import { createAction } from 'redux-actions';
export const clearActiveOfferId = createAction('CREDIT_APPLICATION/CLEAR_ACTIVE_OFFER_ID');
export const clearApplicationEnvironment = createAction('CLEAR_APPLICATION_ENVIRONMENT');
export const clearApproveChargeFlowData = createAction('CREDIT_APPLICATION/CLEAR_APPROVE_CHARGE_FLOW_DATA');
export const clearPersonalInfo = createAction('CREDIT_APPLICATION/CLEAR_PERSONAL_INFO');
export const clearPractice = createAction('CREDIT_APPLICATION/CLEAR_PRACTICE');
export const clearProveApp = createAction('CLEAR_PROVE_APP');
export const clearProveBypass = createAction('CLEAR_PROVE_BYPASS');
export const clearProveFail = createAction('CLEAR_PROVE_FAIL');
export const clearProveVerify = createAction('CLEAR_PROVE_VERIFY');
export const setActiveOfferId = createAction('CREDIT_APPLICATION/SET_ACTIVE_OFFER_ID');
export const setApplicationEnvironment = createAction('SET_APPLICATION_ENVIRONMENT');
export const setApproveChargeFlowData = createAction('CREDIT_APPLICATION/SET_APPROVE_CHARGE_FLOW_DATA');
export const setApprovedApplication = createAction('CREDIT_APPLICATION/SET_APPROVED_APPLICATION');
export const setCreditApplication = createAction('CREDIT_APPLICATION/SET_CREDIT_APPLICATION');
export const setLenderName = createAction('CREDIT_APPLICATION/SET_LENDER_NAME');
export const setLenderReferenceId = createAction('CREDIT_APPLICATION/SET_LENDER_REFERENCE_ID');
export const setPendingDecisionDetails = createAction('CREDIT_APPLICATION/SET_PENDING_DECISION_DETAILS');
export const setPersonalInfo = createAction('CREDIT_APPLICATION/SET_PERSONAL_INFO');
export const setPersonalInfoOTA = createAction('CREDIT_APPLICATION/SET_PERSONAL_INFO_OTA');
export const setPractice = createAction('CREDIT_APPLICATION/SET_PRACTICE');
export const setPrequalification = createAction('CREDIT_APPLICATION/SET_PREQUALIFICATION');
export const setPrequalifications = createAction('CREDIT_APPLICATION/SET_PREQUALIFICATIONS');
export const setProveApp = createAction('SET_PROVE_APP');
export const setProveBypass = createAction('SET_PROVE_BYPASS');
export const setProveFail = createAction('SET_PROVE_FAIL');
export const setProveVerify = createAction('SET_PROVE_VERIFY');
export const setSigningUrl = createAction('CREDIT_APPLICATION/SET_SIGNING_URL');
